/**
 * TanStack Router: /performance/new
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceNewPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceNewPage from '@/app/performance/new/page'

/**
 * Route: /performance/new
 * Layout: _auth (authenticated)
 * Component: PerformanceNewPage
 */
export const Route = createFileRoute('/_auth/performance/new')({
  component: PerformanceNewPage,
})
